export default function SmallInfo({ title, children, ...props }) {
    return (
        <div>
            <p className="uppercase text-xxs font-sans font-black text-green-100 mb-1">{title}</p>
            <div className="text-xs" {...props}>{children}</div>
        </div>
    )
}